import { DateTime } from 'luxon'

import type { ReservationRich } from '@/assets/composables/types'

export const hasParkingReservationStarted = (
  reservation: Pick<ReservationRich, 'date' | 'partOfDay'>,
  now: DateTime = DateTime.utc(),
): boolean => {
  const date = reservation.date?.toISODate()
  const startTime = reservation.partOfDay.range[0]
  if (!date || !startTime) return false

  // Match the existing backend ReturnCard rule: reservation dates and part-of-day
  // boundaries are interpreted in UTC, independently of the device's time zone.
  // This is only a UI hint; the server still checks time and ownership itself.
  const start = DateTime.fromISO(`${date}T${startTime}`, { zone: 'UTC' })
  return start.isValid && now.isValid && now.toMillis() >= start.toMillis()
}
